import { Link } from 'react-router-dom'
import { SubscriptionStatusBadge } from '@/components/SubscriptionStatusBadge'
import { ShipmentAutomationBadge } from '@/components/ShipmentAutomationBadge'
import { CustomerValidationLine } from '@/components/customer/CustomerValidationLine'
import { canBulkActivate } from '@/lib/bulkActivation'
import { formatCustomerNumber, getCustomerName, getCustomerStartDate } from '@/lib/customer'
import { formatDate } from '@/lib/format'
import type { Customer } from '@/api/types'

interface CustomerTableRowProps {
  customer: Customer
  isSelected: boolean
  hasSelectionColumn: boolean
  onToggleSelected: (customerId: number) => void
}

export function CustomerTableRow({
  customer,
  isSelected,
  hasSelectionColumn,
  onToggleSelected
}: CustomerTableRowProps): React.ReactElement {
  const name = getCustomerName(customer)
  const canSelect = canBulkActivate(customer)

  return (
    <tr className="border-t border-border/70">
      {hasSelectionColumn && (
        <td className="py-4 pl-6 pr-3">
          <input
            type="checkbox"
            aria-label={`Markera ${name}`}
            className="size-4 align-middle accent-primary"
            checked={isSelected}
            disabled={!canSelect}
            onChange={() => onToggleSelected(customer.id)}
          />
        </td>
      )}
      <td className="px-3 py-4 font-medium">
        <Link
          to={`/customers/${customer.id}`}
          className="hover:underline"
        >
          {name}
        </Link>
        <span className="mt-1 block text-xs font-normal text-muted-foreground">{formatCustomerNumber(customer.id)}</span>
        <CustomerValidationLine customer={customer} />
      </td>
      <td className="px-3 py-4 text-muted-foreground">{customer.email ?? '-'}</td>
      <td className="px-3 py-4 text-muted-foreground">{customer.identity_number ?? '-'}</td>
      <td className="px-3 py-4 text-muted-foreground">{customer.hitrate_agent_name || 'N/A'}</td>
      <td className="px-3 py-4 text-center">
        <SubscriptionStatusBadge subscription={customer.subscription} />
      </td>
      <td className="px-3 py-4 text-center">
        <ShipmentAutomationBadge subscription={customer.subscription} />
      </td>
      <td className="py-4 pl-3 pr-6 text-muted-foreground">{formatDate(getCustomerStartDate(customer))}</td>
    </tr>
  )
}
